<template>
  <div class="app-container" style="padding: 0 2rem;">
    <h1>Find Services Near You</h1>
    <div class="d-flex flex-row flex-wrap">
      
        <div class="pr-4">
          <multiselect
            v-model="radius"
            :options="radiusOptions"
            :searchable="false"
            :show-labels="false"
            placeholder="Radius"
            class="mt-4 mb-4"
          >
            <template v-slot:singleLabel="{ option }">
              {{ option }} miles
            </template>
            <template v-slot:option="{ option }">
              <input type="checkbox" :checked="radius === option" />
              {{ option }} miles
            </template>
            
          </multiselect>
        </div>


      <div class="filters">
        <label class="pr-6 mt-4 mb-4 checkbox-label">
          <input type="checkbox" v-model="filters.naid_aaa">
          <span>NAID AAA</span>
        </label>
        <label class="pr-6 mt-4 mb-4 checkbox-label">
          <input type="checkbox" v-model="filters.prism_privacy">
          <span>Privacy+</span>
        </label>
        <label class="pr-6 mt-4 mb-4 checkbox-label">
          <input type="checkbox" v-model="filters.member">
          <span>i-SIGMA Member</span>
        </label>
        <!-- <label class="mt-4 mb-4 checkbox-label">
          <input type="checkbox" v-model="filters.industry_supplier">
          <span>Industry Supplier</span>
        </label> -->
      </div>

      <div class="pr-4">
          <multiselect
            v-model="filterOptionsValue"
            :options="filterOptions"
            :multiple="true"
            :searchable="false"
            :close-on-select="false"
            :clear-on-select="false"
            :preserve-search="true"
            placeholder=""
            class="mt-4 mb-4"
          >
            <template v-slot:selection>
              <span
                class="multiselect__single"
              >
                Filter Options
              </span>
            </template>
            <template v-slot:option="{ option }">
              <input type="checkbox" :checked="filterOptionsValue.indexOf(option) >= 0" /> {{ option }}
            </template>
          </multiselect>
      </div>
    </div>

    <div id="results-section">
      <div class="col-6 d-flex flex-col left-col" style="padding-top: 1rem;">
        <div class="filter-section">
          <div id="addressInput">
            <input
              v-model="addressQuery"
              type="text"
              placeholder="Search (Enter Address or Zip Code)"
              ref="addressInput"
              @focus="initAutocomplete"
              @keyup.enter.prevent="textSearch"
            >     
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M14 14L11.1 11.1M12.6667 7.33333C12.6667 10.2789 10.2789 12.6667 7.33333 12.6667C4.38781 12.6667 2 10.2789 2 7.33333C2 4.38781 4.38781 2 7.33333 2C10.2789 2 12.6667 4.38781 12.6667 7.33333Z" stroke="#98A2B3" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/></svg>
          </div>

          <button class="isl-btn isl-btn-primary" @click="textSearch">
            Search
          </button>
        </div>

        <div id="mobile-map-container">
          <div id="mobile-map"></div>
        </div>
        
        <template v-if="searched">
          <h3>Search Results:</h3>
          <div v-if="filteredLocations.length" ref='listSection'>
            <ListItem
              v-for="(location, i) in filteredLocations"
              :key="location.id"
              :value="location"
              :ref="location.id"
              @showOnMap="() => showOnMap(location, i)"
            />
          </div>
          <NoResults v-if="!nearbyLocations.length" />
        </template>
      </div>

      <div id="map-container" class="col-6">
        <div id="map"></div>
      </div>
    </div>

  </div>
</template>

<script>
import axios from "axios";
import NoResults from "@/components/NoResults.vue";
import Multiselect from 'vue-multiselect'
import ListItem from "./ListItem.vue";

export default {
  components: {
    Multiselect,
    ListItem,
    NoResults,
  },
  data() {
    return {
      loading: false,
      searched: false,
      radius: 25,
      radiusOptions: [25, 50, 100, 500],
      filterOptionsValue: [],
      filterOptions: [],
      zipcode: '',
      filters: {
        naid_aaa: false,
        prism_privacy: false,
        member: false,
        // industry_supplier: false,
      },
      nearbyLocations: [],
      filteredLocations: [],
      map: null,
      markers: [],
      center: null,
      infoWindow: null,

      markerIcon: {
        active: false,
        path: "M14.4999 0C9.16983 0 4.83325 4.18704 4.83325 9.33335C4.83325 10.8783 5.2333 12.4101 5.99382 13.7687L13.9713 27.6992C14.0775 27.8849 14.2799 28 14.4999 28C14.72 28 14.9224 27.8849 15.0286 27.6992L23.009 13.7641C23.7666 12.4101 24.1666 10.8782 24.1666 9.3333C24.1666 4.18704 19.83 0 14.4999 0ZM14.4999 14C11.8349 14 9.66662 11.9065 9.66662 9.33335C9.66662 6.7602 11.8349 4.6667 14.4999 4.6667C17.165 4.6667 19.3333 6.7602 19.3333 9.33335C19.3333 11.9065 17.165 14 14.4999 14Z",
        fillColor: "#614B79",
        fillOpacity: 1,
        strokeWeight: 0,
        anchor: new window.google.maps.Point(23.5, 45),
      },
      activeMarkerIcon: {
        active: true,
        path: "M21.5001 0C13.5968 0 7.16675 6.28056 7.16675 14C7.16675 16.3174 7.75993 18.6151 8.88759 20.6531L20.7163 41.5488C20.8738 41.8274 21.1738 42 21.5001 42C21.8264 42 22.1265 41.8274 22.2839 41.5488L34.117 20.6462C35.2403 18.6151 35.8335 16.3173 35.8335 13.9999C35.8335 6.28056 29.4034 0 21.5001 0ZM21.5001 21C17.5485 21 14.3335 17.8598 14.3335 14C14.3335 10.1403 17.5485 7.00005 21.5001 7.00005C25.4517 7.00005 28.6667 10.1403 28.6667 14C28.6667 17.8598 25.4517 21 21.5001 21Z",
        fillColor: "#01494A",
        fillOpacity: 1,
        strokeWeight: 0,
        anchor: new window.google.maps.Point(31.7, 64),
      },
      addressQuery: '',
    };
  },
  mounted() {
    this.initMap();
  },
  watch: {
    center: 'doTheSearch',
    radius: 'doTheSearch',
    filters: {
      deep: true,
      handler: 'applyFilters'
    },
    filterOptionsValue: {
      deep: true,
      handler (v, o) {
        if (o.length) {
          this.applyFilters()
        }
      }
    },
  },
  methods: {
    initMap() {
      if (!this.map) {
        const elementId = screen.width < 768 ? 'mobile-map' : 'map'
        const latlng = new window.google.maps.LatLng(37.09024, -95.712891);

        this.map = new window.google.maps.Map(document.getElementById(elementId), {
          zoom: 3,
          disableDefaultUI: true,
          center: latlng,
        });
      }

      if (!this.infoWindow) {
        this.infoWindow = new window.google.maps.InfoWindow(); // Initialize InfoWindow
        window.google.maps.event.addListener(this.map, "click", () => {
          this.hideInfoWindow();
        });
      }
    },
    updateMap(locations = []) {
      // Create map instance if it doesn't exist
      if (!this.map) {
        this.map = new window.google.maps.Map(document.getElementById('map'), {
          zoom: 10,
        });
      }

      if (this.markers) {
        for (let i = 0; i < this.markers.length; i++) {
          this.markers[i].setVisible(false)
          this.markers[i].setMap(null)
        }
      }

      this.markers = []


      const bounds = new window.google.maps.LatLngBounds();

      locations.forEach((location, i) => {
        const position = {
          lat: location.lat,
          lng: location.lon,
        };

        const marker = new window.google.maps.Marker({
          icon: this.markerIcon,
          position,
          map: this.map,
          zIndex: 1,
        });

        marker.rhythm_id = location.rhythm_id;

        marker.addListener('click', () => {
          if (i >= 0) {
            this.highlightInList(i);
            this.highlightMarker(marker);
            this.openInfoWindow(location, marker);
          }
        });

        marker.rhythm_id = location.rhythm_id;

        this.markers.push(marker); // Store markers for later reference
        bounds.extend(marker.getPosition()); // Extend bounds to include this marker
      });


      // Adjust the map to fit all markers
      if (locations.length) {
        this.map.fitBounds(bounds);
        if (this.map.getZoom() > 11) {
          this.map.setZoom(11); // Limit zoom to 10
        }
      }
    },
    initAutocomplete() {
      const autocomplete = new window.google.maps.places.Autocomplete(this.$refs.addressInput);

      autocomplete.addListener('place_changed', () => {
        this.center = null
        const place = autocomplete.getPlace();
        if (place.geometry) {
          this.center = {
            lat: place.geometry.location.lat(),
            lng: place.geometry.location.lng(),
          };
        }
      });
    },
    textSearch () {
      const placesService = new window.google.maps.places.PlacesService(document.createElement('div'));
      placesService.textSearch({ query: this.addressQuery }, (results, status) => {
        if (status === window.google.maps.places.PlacesServiceStatus.OK && results.length > 0) {
          const place = results[0];

          if (place.geometry) {
            this.center = {
              lat: place.geometry.location.lat(),
              lng: place.geometry.location.lng(),
            };
            return
          }
        }

        this.searched = true
      })
    },
    async doTheSearch () {
      if (!this.center) return
      if (!this.radius) return
      
      const options = {
        method: 'POST',
        url: '/wp-admin/admin-ajax.php',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        data: {
          action: 'org_search_locations',
          lat: this.center.lat,
          lon: this.center.lng,
          radius: this.radius
        }
      };

      try {
        this.loading = true
        const { data } = await axios.request(options)

        let unique = {}

        const nearbyLocations = [];

        for (let i = 0; i < data.length; i++) {
          const item = data[i];
          
          const certifications = JSON.parse(item.certifications)
          let naid_aaa = false
          let prism_privacy = false
          let endorsements = {}

          certifications.forEach((c) => {
            if (c.program_id === 'NAID-AAA-CERTIFICATION') {
              naid_aaa = true
            }
            if (c.program_id === 'PRISM-PRIVACY-CERTIFICATION') {
              prism_privacy = true
            }

            if (c.endorsements.length) {
              for (let j = 0; j < c.endorsements.length; j++) {
                const e = c.endorsements[j];
                endorsements[e] = true;
                unique[e] = true;
              }
            }
          })


          const type = item.type.toLowerCase();
  
          nearbyLocations.push({
            ...item,
            type: type.indexOf('vendor') > 0 ? 'industry_supplier' : 'member',
            lat: parseFloat(item.lat),
            lon: parseFloat(item.lon),
            endorsements,
            naid_aaa,
            prism_privacy,
            certifications: JSON.parse(item.certifications)
          })
        }

        this.nearbyLocations = nearbyLocations;

        const uniqueEndorsements = Object.keys(unique)
        this.filterOptions = [
          ...uniqueEndorsements
        ];

        this.filterOptionsValue = []

        this.applyFilters()
      } catch (err) {
        alert(err)
      } finally {
        this.loading = false
        this.searched = true
      }
    },
    applyFilters () {
      this.unhighlightInList();
      this.unhighlightMarkers();
      this.hideInfoWindow()

      this.filteredLocations = [
        ...this.nearbyLocations.filter((l) => {

        if (!this.filters.naid_aaa && !this.filters.prism_privacy) {
          // show all
        } else {
          if (this.filters.naid_aaa && !l.naid_aaa) {
            return false
          } 

          if (this.filters.prism_privacy && !l.prism_privacy) {
            return false
          }
        }


        // let filteredByType = false;
        if (!this.filters.member) {
          // show all
          // filteredByType = true
        } else {
          if (this.filters.member && l.type !== 'member') {
            return false
          }
        }

        return this.hasAnyOfEndorsements(l.endorsements)
      })
    ]

      this.updateMap(this.filteredLocations)
    },
    hasAnyOfEndorsements (endorsements) {
      if (!this.filterOptionsValue.length) return true

      let has = false
      for (let i = 0; i < this.filterOptionsValue.length; i++) {
        if (endorsements[this.filterOptionsValue[i]]) {
          has = true;
          break;
        }
      }

      return has
    },
    // setData(items) {
    //   // filters
    //   const filteredItems = [];
    //   for (let i = 0; i < items.length; i++) {
    //     item = {
    //       ...items[i],
    //       lat: parseFloat(items[i].lat),
    //       lon: parseFloat(items[i].lon),
    //       certifications: JSON.parse(items[i].certifications)
    //     }

    //     if (this.filters.naid) {
    //       items.certifications
    //     }
        
    //   }
    // }
    unhighlightMarkers () {
      for (let i = 0; i < this.markers.length; i++) {
        if (this.markers[i].icon.active) {
          this.markers[i].setIcon(this.markerIcon);
          this.markers[i].setZIndex(1);
        }
      }
    },
    hideInfoWindow () {
      if (this.infoWindow) {
        this.infoWindow.close()
      }
    },
    highlightMarker (marker) {
      this.unhighlightMarkers();

      if (marker) {
        marker.setIcon(this.activeMarkerIcon);
        marker.setZIndex(10);
      }
    },
    unhighlightInList () {
      const highlightedElements = document.querySelectorAll('.member.highlighted');
      for (let i = 0; i < highlightedElements.length; i++) {
        highlightedElements[i].className = 'member'
      }
    },
    highlightInList(index, scroll = true) {
      this.unhighlightInList();

      if (index < 0) {
        return
      }

      const element = this.$refs.listSection.children[index]
      if (element) {
        if (scroll) {
          element.scrollIntoView({ behavior: "smooth", block: "center" });
        }
        element.className = 'member highlighted'
      }
    },
    showOnMap(location, index) {
      const marker = this.markers.find((m) => m.rhythm_id === location.rhythm_id);
      if (marker) {
        this.highlightMarker(marker)
        this.openInfoWindow(location, marker)
      }

      this.highlightInList(index, false);
    },
    openInfoWindow (location, marker) {
      this.infoWindow.setContent(`<div class="info-window">
        <h4>${location.name}</h4>
        <p>${location.address_line1}</p>
        <p>${location.city},${location.state ? location.state + ', ' : '' }${ location.postal_code }</p>
        <p>${location.main_phone_number}</p>
        <a href="/?rhythm_id=${location.rhythm_id}">View Details</a>
      </div>`);
      this.infoWindow.open(this.map, marker);
    }
  }
};
</script>

<style>
fieldset[disabled] .multiselect {
    pointer-events: none
}



.multiselect,.multiselect__input,.multiselect__single {
    font-family: inherit;
    touch-action: manipulation
}

.multiselect {
    box-sizing: content-box;
    display: block;
    position: relative;
    width: 100%;
    min-height: 40px;
    text-align: left;
    color: #344054;

}

.multiselect * {
    box-sizing: border-box
}

.multiselect:focus {
    outline: 0
}

.multiselect--disabled {
    background: #ededed;
    pointer-events: none;
    opacity: .6
}

.multiselect--active {
    z-index: 50
}


.multiselect--active .multiselect__select {
    transform: rotate(180deg)
}


.multiselect--above.multiselect--active .multiselect__current,.multiselect--above.multiselect--active .multiselect__input,.multiselect--above.multiselect--active .multiselect__tags {
    border-top-left-radius: 0;
    border-top-right-radius: 0
}

.multiselect__input {
    padding: 0 0 0 8px;
    margin-bottom: 8px
}

/*
.multiselect__input,.multiselect__single {
    position: relative;
    display: inline-block;
    min-height: 20px;
    line-height: 20px;
    border: 0;
    border-radius: 5px;
    background: #fff;
    width: 100%;
    transition: border .1s ease;
    box-sizing: border-box;
    vertical-align: top
} */

/* .multiselect__input::-moz-placeholder {
    color: #35495e
}

.multiselect__input::placeholder {
    color: #35495e
}

.multiselect__tag~.multiselect__input,.multiselect__tag~.multiselect__single {
    width: auto
}

.multiselect__input:hover,.multiselect__single:hover {
    border-color: #cfcfcf
}

.multiselect__input:focus,.multiselect__single:focus {
    border-color: #a8a8a8;
    outline: 0
} */

.multiselect__tags > span {
    font-size: 14px;
    padding: 0 0 0 5px;
    margin-bottom: 8px;
    white-space: nowrap;
}

.multiselect__tags-wrap {
    display: inline
}

.multiselect__tags {
    min-height: 40px;
    display: block;
    border-radius: 8px;
    padding: 9px 40px 0 8px;
    border: 1px solid #D0D5DD;
    background: #fff;
    font-size: 14px
}

.multiselect__current,.multiselect__select {
    line-height: 16px;
    display: block;
    box-sizing: border-box;
    margin: 0;
    text-decoration: none;
    cursor: pointer
}

.multiselect__current {
    min-height: 40px;
    overflow: hidden;
    padding: 8px 30px 0 12px;
    white-space: nowrap;
    border-radius: 5px;
    border: 1px solid #D0D5DD;
}

.multiselect__select {
    position: absolute;
    width: 40px;
    height: 38px;
    right: 1px;
    top: 1px;
    padding: 4px 8px;
    text-align: center;
    transition: transform .2s ease;

    background-image: url("data:image/svg+xml;charset=utf-8,<svg viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M5 7.5L10 12.5L15 7.5' stroke='%23344054' stroke-width='1.67' stroke-linecap='round' stroke-linejoin='round'/></svg>");
    background-position: center;
    background-size: 20px;
    background-repeat: no-repeat
}

.multiselect__placeholder {
    color: #667085;
    display: inline-block;
}

.multiselect--active .multiselect__placeholder {
    display: none
}

.multiselect__content-wrapper {
    position: absolute;
    display: block;
    background: #fff;

    max-height: 240px;
    overflow: auto;
    width: 300px;
    box-shadow: 0px 5px 11px 0px #00000036;
    border-radius: 8px;
    z-index: 50;
    -webkit-overflow-scrolling: touch
}


#locator-app * {
    font-weight: 400;
    font-size: 14px;
    box-sizing: border-box;
}

#locator-app .multiselect__content {
    list-style: none;
    display: inline-block;
    padding: 0;
    margin: 0;
    min-width: 100%;
    vertical-align: top;
    padding: 0;
}

.multiselect--above .multiselect__content-wrapper {
    bottom: 100%;
}

.multiselect__content::-webkit-scrollbar {
    display: none
}

#locator-app .multiselect__option {
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 1rem;
    margin: 0;
    cursor: pointer;

}

#locator-app .multiselect__option:hover {
  background-color: #d0d5dd75;
}

#locator-app .multiselect__option input[type="checkbox"] {
  margin-right: 8px;
}
/* .multiselect__option {
    display: block;
    padding: 12px;
    min-height: 40px;
    line-height: 16px;
    text-decoration: none;
    text-transform: none;
    vertical-align: middle;
    position: relative;
    cursor: pointer;
    white-space: nowrap
} */

/* .multiselect__option:after {
    top: 0;
    right: 0;
    position: absolute;
    line-height: 40px;
    padding-right: 12px;
    padding-left: 20px;
    font-size: 13px
} */


/* .multiselect__option--selected {
    background: #f3f3f3;
    color: #35495e;
    font-weight: 700
}

.multiselect__option--selected:after {
    content: attr(data-selected);
    color: silver;
    background: inherit
}

.multiselect__option--selected.multiselect__option--highlight {
    background: #ff6a6a;
    color: #fff
} */

/* .multiselect__option--selected.multiselect__option--highlight:after {
    background: #ff6a6a;
    content: attr(data-deselect);
    color: #fff
}

.multiselect--disabled .multiselect__current,.multiselect--disabled .multiselect__select {
    background: #ededed;
    color: #a6a6a6
}

.multiselect__option--disabled {
    background: #ededed!important;
    color: #a6a6a6!important;
    cursor: text;
    pointer-events: none
} */

/* .multiselect__option--group {
    background: #ededed;
    color: #35495e
}

.multiselect__option--group.multiselect__option--highlight {
    background: #35495e;
    color: #fff
}

.multiselect__option--group.multiselect__option--highlight:after {
    background: #35495e
}

.multiselect__option--disabled.multiselect__option--highlight {
    background: #dedede
}

.multiselect__option--group-selected.multiselect__option--highlight {
    background: #ff6a6a;
    color: #fff
} */

/* .multiselect__option--group-selected.multiselect__option--highlight:after {
    background: #ff6a6a;
    content: attr(data-deselect);
    color: #fff
}

.multiselect-enter-active,.multiselect-leave-active {
    transition: all .15s ease
}

.multiselect-enter,.multiselect-leave-active {
    opacity: 0
}

.multiselect__strong {
    margin-bottom: 8px;
    line-height: 20px;
    display: inline-block;
    vertical-align: top
} */



#locator-app h1 {
  /* Find Services Near You */

  margin: 50px 0 20px 0;

  font-family: 'Arial';
  font-style: normal;
  font-weight: 700;
  font-size: 42px;
  line-height: 48px;

  color: #000000;
}

#locator-app h3 {
  margin-top: 3rem;
  margin-bottom: 1.5rem;
  font-family: 'Arial';
  font-style: normal;
  font-weight: 400;
  font-size: 26px;
  line-height: 30px;
  color: #000000;
}

.filters {
  display: flex;
  flex-direction: row;
  align-items: center;
  flex-wrap: wrap;
}


@media screen and (min-width: 1000px) {
  .filters {
    padding: 0 4rem;
  }
}

#addressInput {
  position: relative;
  flex: 1 0 auto;
  margin-right: 1rem;
}

#addressInput input {
  padding-right: 44px;
}

#addressInput svg {
  position: absolute;
  content: '';
  width: 16px;
  height: 16px;
  top: 50%;
  right: 14px;
  transform: translateY(-50%);
}

#results-section {
  margin-top: 40px;
  padding: 1rem 0;
  box-sizing: border-box;
}

/* info window */
#locator-app .gm-style-iw-chr {
    display: none;
}

#locator-app .gm-style-iw {
    padding: 0;
}

#locator-app .gm-style-iw-d {
    padding: 18px 0 0 18px;
}

#locator-app .info-window {
  max-width: 280px;
}

#locator-app .info-window h4 {
  font-size: 14px;
  font-weight: bold;
  margin-bottom: 10px;
}

#locator-app .info-window p {
  font-size: 12px;
  margin-bottom: 4px;
}

#locator-app .gm-style-iw-d a {
  margin-top: 16px;
  font-size: 14px;
  color: #101828;
  display: block;
  border: 0;
  outline: 0;
}


.filter-section {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
}


@media screen and (min-width: 768px) {
  #locator-app .col-6 {
    width: 50%;
  }
  #locator-app .left-col {
    padding-right: 20px;
  }

  #results-section {
    display: flex;
    flex-direction: row;
  }

  #map-container {
    position: sticky;
    top: 0;
    padding: 1rem 0 1rem 20px;
    height: 100vh;
  }

  #map {
    height: 100%;
    border-radius: 1rem;
    overflow: hidden;
  }

  #mobile-map-container {
    display: none;
  }

  body {
    overflow-x: unset !important;
  }
}

@media screen and (max-width: 767px) {
  #locator-app .col-6 {
    width: 100%;
  }

  #map-container {
    display: none;
  }

  #mobile-map-container {
    padding: 2rem 0 0 0;
    height: 40vh;
  }

  #mobile-map {
    height: 100%;
    border-radius: 1rem;
    overflow: hidden;
  }
}
</style>
